
import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext } from "@/script/core/base/ServiceData";
import {
  createNodeContext,
  createCruiseContext,
} from "@/script/apps/recon/config/ReconConfig";
import { Cruise } from "@/script/apps/recon/entity/ReconEntity";
import { DictUtil } from "@/script/core/Dict";

@Options({})
export default class CruiseList extends BaseList {
  private queryEntity: Cruise = {};
  private dataList: Cruise[] = [];
  private nodeList: Node[] = [];
  private dateRange: string[] = [];

  public initData(): ServiceContext {
    return createCruiseContext();
  }

  public initQueryEntity() {
    this.queryEntity = {
      name: "",
    };
    return this.queryEntity;
  }

  protected initOptions() {
    super.initOptions();
    createNodeContext().service.loadFullList<Node[]>((data: Node[]) => {
      this.nodeList = data;
    });
  }

  public beforeLoadList() {
    if (this.queryEntity.state === "") {
      this.queryEntity.state = null;
    }
  }

  public afterLoadList(data: any): void {
    const currDataList: Cruise[] = data.list as Cruise[];
    currDataList.forEach((item) => {
      if (this.serviceContext.typesName) {
        item.typeName = DictUtil.getItemName(this.types, item.type);
      }
    });
    this.dataList = currDataList;
  }
}
